import { action, computed, makeObservable, observable } from 'mobx'

import { ITextMarkupInput } from './markupTextStyle'

export interface ITextMarkupProvider {
  readonly textInputs: ITextMarkupInput[]
}

// Where a host's session text comes from: the editor while one is attached, the store otherwise.
// The host owns it for its lifetime and gives it to both the editor and its session mount, so
// the mount's GL layer outlives editor mounts and a hand-off between them redraws nothing.
export class MarkupEditorTextChannel {
  @observable.ref private provider: ITextMarkupProvider | null = null

  public constructor() {
    makeObservable(this)
  }

  @computed
  public get isAttached(): boolean {
    return this.provider != null
  }

  // null while detached: the mount draws the store's text instead.
  @computed
  public get inputs(): ITextMarkupInput[] | null {
    return this.provider?.textInputs ?? null
  }

  @action.bound
  public attach(provider: ITextMarkupProvider): void {
    this.provider = provider
  }

  // Only the attached provider detaches: an editor unmounting late cannot cut off its successor.
  @action.bound
  public detach(provider: ITextMarkupProvider): void {
    if (this.provider === provider) this.provider = null
  }

  // The host ends the session, whichever editor is attached.
  @action.bound
  public release(): void {
    this.provider = null
  }
}
